export default __webpack_public_path__ + "static/media/28.76bb2b73.svg";